function makeMouseDraggable(el) {
  let active = false
  let startX
  let scrollLeft

  function getOffsetX(e) {
    return e.pageX - el.offsetLeft
  }

  function reset() {
    active = false
    el.classList.remove('dragging')
  }

  el.addEventListener('mousedown', e => {
    active = true
    startX = getOffsetX(e)
    scrollLeft = el.scrollLeft
  })

  el.addEventListener('mouseleave', reset)
  el.addEventListener('mouseup', reset)

  el.addEventListener('mousemove', e => {
    if (!active) return

    el.classList.add('dragging')
    e.preventDefault()
    el.scrollLeft = scrollLeft - (getOffsetX(e) - startX)
  })
}

document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".table-container__table").forEach(makeMouseDraggable)
})
